<template>
  <li>
    <header
      :id="`_bv_${id}_group_dd_header`"
      class="dropdown-header"
    >
      {{ header }}
    </header>
    <ul
      class="list-unstyled"
      :aria-describedby="`_bv_${id}_group_dd_header`"
      role="group"
    >
      <slot />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'BDropdownGroup',
  props: {
    header: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  }

}
</script>
